export default __webpack_public_path__ + "static/media/kelly-sikkema-M98NRBuzbpc-unsplash.b16f37da.jpg";